module.exports = __webpack_public_path__ + "static/media/h270_7.92f91b18a842e5829085d1f91d054dfd.png";